import styles from '../styles.module.scss'

const InvoicesHeader = ({ isInvoicesTab }) => (
    <div className={styles.invoicesTableHeader}>
        <div className={styles.invoice}>
            {isInvoicesTab ? (
                <T>dashboard.subscriptions.invoices.invoice</T>
            ) : (
                <T>dashboard.subscriptions.invoices.receipt</T>
            )}
        </div>
        <div className="date">
            <T>dashboard.subscriptions.invoices.due.date</T>
        </div>
        <div className="amount">
            <T>dashboard.subscriptions.invoices.amount</T>
        </div>
        <div className="status">
            <T>dashboard.subscriptions.invoices.status</T>
        </div>
    </div>
)

export default InvoicesHeader
